import React, { useState, useRef, useEffect } from 'react';
import { products as productsApi } from '../utils/api';

export default function ProductAutocomplete({ value, productId, onChange, placeholder = 'Produto...' }) {
  const [query, setQuery]             = useState(value || '');
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen]               = useState(false);
  const [loading, setLoading]         = useState(false);
  const debounceRef                   = useRef(null);
  const wrapperRef                    = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => { setQuery(value || ''); }, [value]);

  function handleInput(e) {
    const v = e.target.value;
    setQuery(v);
    onChange({ product: v, product_id: null });
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (v.length < 2) { setSuggestions([]); setOpen(false); return; }
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const results = await productsApi.search(v);
        setSuggestions(results);
        setOpen(true);
      } catch { setSuggestions([]); }
      finally { setLoading(false); }
    }, 250);
  }

  function selectProduct(p) {
    setQuery(p.name);
    onChange({ product: p.name, product_id: p.id });
    setOpen(false);
    setSuggestions([]);
  }

  async function createAndSelect() {
    if (!query.trim()) return;
    try {
      const p = await productsApi.create({ name: query.trim() });
      selectProduct(p);
    } catch {}
  }

  return (
    <div ref={wrapperRef} style={{ position: 'relative' }}>
      <input
        value={query}
        onChange={handleInput}
        onFocus={() => query.length >= 2 && suggestions.length > 0 && setOpen(true)}
        placeholder={placeholder}
        style={{ width: '100%' }}
      />
      {productId && (
        <span style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)', fontSize: 10, color: 'var(--pantone)', background: 'var(--accent-light)', padding: '1px 5px', borderRadius: 8 }}>
          vinculado
        </span>
      )}
      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
          background: 'white', border: '1px solid var(--gray-200)',
          borderRadius: 'var(--radius)', boxShadow: 'var(--shadow-lg)',
          maxHeight: 200, overflowY: 'auto',
        }}>
          {loading && <div style={{ padding: '8px 12px', fontSize: 12, color: 'var(--gray-400)' }}>Buscando...</div>}
          {!loading && suggestions.map(p => (
            <div key={p.id}
              onMouseDown={() => selectProduct(p)}
              style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid var(--gray-100)' }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--gray-50)'}
              onMouseLeave={e => e.currentTarget.style.background = 'white'}
            >
              <div style={{ fontWeight: 600 }}>{p.name}</div>
              {p.category && <div style={{ fontSize: 11, color: 'var(--gray-400)' }}>{p.category}</div>}
            </div>
          ))}
          {!loading && query.trim() && !suggestions.find(p => p.name.toLowerCase() === query.trim().toLowerCase()) && (
            <div
              onMouseDown={createAndSelect}
              style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 13, color: 'var(--blue)', fontWeight: 600 }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--gray-50)'}
              onMouseLeave={e => e.currentTarget.style.background = 'white'}
            >
              + Criar produto "{query.trim()}"
            </div>
          )}
        </div>
      )}
    </div>
  );
}
